// extracted by mini-css-extract-plugin
export default {"wrapper":"targetRadioBox_wrapper__1JSv8","radio":"targetRadioBox_radio__ocozy"};